function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class TemplateDraft {
    constructor(resp){
        _define_property(this, "content", void 0);
        _define_property(this, "timestamp", void 0);
        _define_property(this, "templateId", void 0);
        _define_property(this, "templateType", void 0);
        this.content = resp.content;
        this.timestamp = resp.timestamp;
        this.templateId = resp.templateId;
        this.templateType = resp.templateType;
    }
}
